module.exports = __webpack_public_path__ + "img/employee.0afcafd7.svg";